import { normalizeTaskDueDate } from '@/modules/common/helpers/normalizeTaskDueDate.ts';

const parseUtc = (value: string) => Date.parse(normalizeTaskDueDate(value.replace(/Z$/, '+00:00')));

export const getFirstTaskOccurrence = (task: {
  start_date: string;
  first_due_date: string;
  recurrency_rule?: string;
  task_results?: ReadonlyArray<{
    due_date?: string;
    end_date?: string;
    deleted_at?: string;
  }>;
}): string | undefined => {
  if (!task.recurrency_rule) return task.start_date;

  const duration = parseUtc(task.first_due_date) - parseUtc(task.start_date);
  if (!Number.isFinite(duration) || duration <= 0) return undefined;

  let earliestDue = Infinity;
  for (const result of task.task_results ?? []) {
    if (result.deleted_at) continue;
    const due = parseUtc(result.due_date ?? result.end_date ?? '');
    if (Number.isFinite(due) && due < earliestDue) earliestDue = due;
  }

  return earliestDue === Infinity
    ? undefined
    : new Date(earliestDue - duration).toISOString().replace(/Z$/, '+00:00');
};
